import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import lvlalpha from "../../Assets/lvlalpha.png";
import smf from "../../Assets/smf.png";
import iserveu from "../../Assets/iserveu.png";
import hyscaler from "../../Assets/hyscaler.png";
import skyyskill from '../../Assets/skyyskill.png'

function Experience() {

  const experienceData = [ 
     {
      date: "May 2025 - Present",
      designation: "Frontend Developer",
      companyName: "Skyy Skill Academy",
      companyLogo: skyyskill , 
      skills: ["Next.js", "React.js", "Vercel", "MongoDB",
  "UI/UX-Figma", "User Flows", "DFD", "SSD", "FRD",
  "PWA", "Automation",
  "AI-Powered Development", "LLM Integration", "AI Workflow Automation"]
    },
    {
      date: "Dec 2023 - March 2025",
      designation: "Frontend Developer (Freelance)",
      companyName: "LVLAlpha",
      companyLogo: lvlalpha, 
      skills: ["Angular.js","React.js","Vercel", "User Flows", "DFD", "SSD", "FRD", "PWA", "MongoDB",  "UI/UX-Figma"]
    },
    {
      date: "Feb 2024 - March 2025",
      designation: "Web Developer (Freelance)",
      companyName: "Save Medha Foundation",
      companyLogo: smf, 
      skills: ["Angular.js", "WordPress", "WooCommerce", "UI/UX-Figma","SEO", "Canva", "Wireframing", "Prototyping","Razorpay Integration"]
    },
    {
      date: "May 2023 - Dec 2023",
      designation: "Product Management Trainee",
      companyName: "iServeU",
      companyLogo: iserveu, 
      skills: ["Product Management", "PRD-Documentation", "Agile Methodologies", "Market Research", "Competitor Analysis", "User Analytics"]
    },
    {
      date: "Jan 2023 - April 2023",
      designation: "Software Developer Trainee",
      companyName: "Hyscaler",
      companyLogo: hyscaler, 
      skills: ["Angular.js", "React.js", "Laravel", "MySQL", "UI/UX Improvements", "Next.js", "Django"]
    }
  ];

  return (
    <Container fluid className="experience-section" id="experience">
      <Container>
        <Row>
          <Col md={12}>
            <div className="timeline">
              {experienceData.map((experience, index) => (
                <div key={index} className="timeline-item">
                  <div className="timeline-date">{experience.date}</div>
                  <div className="timeline-content">
                    <div className="timeline-header">
                      <img src={experience.companyLogo} alt={experience.companyName} className="company-logo" />
                      <div className="timeline-details">
                        <h3>{experience.designation}</h3>
                        <p>{experience.companyName}</p>
                      </div>
                    </div>
                    <div className="skills-container">
                      {experience.skills.map((skill, i) => (
                        <span key={i} className="skill-badge">{skill}</span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Experience;
